import consumer from "./consumer"

const showLiveConfirmation = (message) => {
  let banner = document.querySelector("[data-exhibitor-space-live-message]")
  if (!banner) {
    banner = document.createElement("div")
    banner.className = "exhibitor-space-live-message"
    banner.dataset.exhibitorSpaceLiveMessage = "true"
    banner.setAttribute("role", "status")
    document.body.appendChild(banner)
  }

  banner.textContent = message
  banner.classList.remove("is-visible")
  void banner.offsetWidth
  banner.classList.add("is-visible")
  window.clearTimeout(banner.dismissTimer)
  banner.dismissTimer = window.setTimeout(() => {
    banner.classList.remove("is-visible")
  }, 5000)
}

const refreshVisibleSection = async () => {
  const root = document.querySelector("[data-exhibitor-space-live-root]")
  if (!root) return

  try {
    const response = await fetch(window.location.href, {
      headers: { Accept: "text/html" },
      credentials: "same-origin",
      cache: "no-store"
    })
    if (!response.ok) return

    const nextDocument = new DOMParser().parseFromString(await response.text(), "text/html")
    const nextRoot = nextDocument.querySelector("[data-exhibitor-space-live-root]")
    if (nextRoot) root.replaceWith(nextRoot)
  } catch (_) {
    // La confirmation reste visible même si le fragment n'a pas pu être actualisé.
  }
}

let subscribed = false

document.addEventListener("turbolinks:load", () => {
  if (subscribed || document.body?.dataset.exhibitorSpaceUser !== "1") return
  subscribed = true

  consumer.subscriptions.create("ExhibitorSpaceUpdatesChannel", {
    received(data) {
      if (!data?.message) return
      showLiveConfirmation(data.message)
      refreshVisibleSection()
    }
  })
})
